
export const BOARD_TYPE = {B144:144, B100:100, B64:64};

export const COLOR = {WHITE:1, BLACK:2};
export const PIECE_TYPE = {'NONE':0, 'WHITE':1, 'BLACK':2, 'WHITE_QUEEN':3, 'BLACK_QUEEN':4, 'CAPTURED_WHITE':-1, 'CAPTURED_BLACK':-2};
export const PIECE_SYMBOL = ["", 'w', 'b', 'W', 'B', '', ''];
export const SQUARE_TYPE = {'WHITE': 0, 'BLACK':1};

let config = {};
const development = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

if (development) {
    config.FMJD_RESULTS_URL = "https://results.fmjd.org/";
    //config.FMJD_RESULTS_URL = "http://localhost:39205/results/";
    config.THIS_URL = 'http://localhost:3000/#/';
} else {
    config.FMJD_RESULTS_URL = "https://results.fmjd.org/";
    config.THIS_URL = 'https://results.fmjd.org/games/#/';
}

const FMJD_RESULTS_URL = config.FMJD_RESULTS_URL;
export const THIS_URL = config.THIS_URL;
const FMJD_CORE_SCRIPTS_URL = FMJD_RESULTS_URL + "engine/";

export const FMJD_CORE_GET_GAMES_SCRIPT = FMJD_CORE_SCRIPTS_URL + "gg1.php";
export const FMJD_CORE_POST_GAMES_SCRIPT = FMJD_CORE_SCRIPTS_URL + "game_post.php";
export const FMJD_CORE_GET_SETTINGS_SCRIPT = FMJD_CORE_SCRIPTS_URL + "games_settings_get.php";
export const FMJD_CORE_POST_COMMENT_SCRIPT = FMJD_CORE_SCRIPTS_URL + "game_comments_post.php";
export const FMJD_CORE_GET_COMMENTS_SCRIPT = FMJD_CORE_SCRIPTS_URL + "game_comments_get.php";
export const FMJD_CORE_GET_POSITIONS_SCRIPT = FMJD_CORE_SCRIPTS_URL + "position_get.php";

export const FMJD_GET_GAMES_SRC_PATH = "https://fmjd.space/game_open.php";
export const FMJD_IMAGES_URL = "https://results.fmjd.org/images/";
export const FMJD_PHOTO_URL = "https://fmjd.org/downloads/DA/images/";
export const FMJD_FLAGS_URL = FMJD_RESULTS_URL + "images/flags/";
export const FMJD_TOURNAMENTS_URL = FMJD_RESULTS_URL + "tournaments/";
export const EMPTY_IMG = FMJD_IMAGES_URL + 'empty.png';
export const AVATAR_IMG = FMJD_IMAGES_URL + 'avatar.png';
export const GAMES_VIEWER_URL = THIS_URL + 'round/';

export const ModalResult = {
    RESULT_NONE : 0,
    RESULT_YES : 1,
    RESULT_NO : 2,
    RESULT_CANCEL : 3,
    RESULT_OK : 4,
};


// WEBPACK FOOTER //
// ./src/board/Constans.js